/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function FileQuestionMarkIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="file-question-mark"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M6.5 2.5C5.395 2.5 4.5 3.395 4.5 4.5L4.5 19.5C4.5 20.605 5.395 21.5 6.5 21.5L17.5 21.5C18.605 21.5 19.5 20.605 19.5 19.5L19.5 8.828C19.5 8.298 19.289 7.789 18.914 7.414L14.586 3.086C14.211 2.711 13.702 2.5 13.172 2.5L6.5 2.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.5 10L9.5 9.5C9.5 8.119 10.619 7 12 7C13.381 7 14.5 8.119 14.5 9.5L14.5 10.042C14.5 10.947 14.025 11.785 13.25 12.25C12.475 12.715 12 13.553 12 14.458L12 14.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 17.5L12 17.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(133.333)} data-tinysvg-stroke-width="133.333" />
    </svg>
  )
}
